<template>
  <div
    :class="{
      'consult-common-list-item': true,
      'full-minus-list-item': itemFiedParsed.full_minus_prices,
      'show-schedule-item': isShowSchedule
    }"
    @click="_toTeacherList"
    v-stat="stat"
  >
    <div
      class="consult-common-list-item-avatar"
      v-lazy:background-image="imgZip(item.avatar, isShowSchedule ? 300 : 120)"
    >
      <div
        :class="['recent-tag', 'recent-tag-' + itemFiedParsed._recent_type_]"
        v-if="itemFiedParsed._recent_type_"
      ></div>
      <!-- 匹配度 -->
      <div class="match-rate" v-if="showMatchRate && +item.match_rate > 0">
        匹配度: {{ item.match_rate }}%
      </div>
      <img
        v-if="isShowRecommendIcon"
        class="consult-common-list-item-avatar-corner"
        src="~images/consult/indexV5/icon-recommend-corner.png"
      />
      <slot name="avatarTag"></slot>
    </div>
    <div class="consult-common-list-item-content">
      <div class="consult-common-list-item-info">
        <a
          :href="'/consult/' + itemFiedParsed.user_id + '.html'"
          class="consult-common-list-item-name"
          @click.prevent
          >{{ itemFiedParsed.name }}</a
        >
        <span class="consult-common-list-item-zx-num">
          {{ itemFiedParsed.zx_num }}人次咨询
        </span>
        <template v-if="itemFiedParsed.experience_year">
          <i class="consult-common-list-item-cur">·</i>
          <span class="consult-common-list-item-experience-year">
            从业{{ itemFiedParsed.experience_year }}年
          </span>
        </template>

        <div class="consult-common-list-item-info-price">
          <del
            :class="['consult-common-list-item-origin-price']"
            v-if="itemFiedParsed.origin_price !== undefined"
            >¥{{
              +itemFiedParsed[priceFilterInt ? 'oPriceInt' : 'origin_price']
            }}</del
          >

          <span
            v-if="
              typeof itemFiedParsed.price !== 'undefined' &&
              !isShowActivityPricesDetail
            "
            :class="['consult-common-list-item-price']"
          >
            {{ +itemFiedParsed[priceFilterInt ? 'priceInt' : 'price'] }}</span
          >
        </div>
      </div>

      <p class="consult-common-list-item-honer" v-if="itemFiedParsed.honor">
        {{ itemFiedParsed.honor }}
      </p>

      <div
        class="consult-common-list-item-tags-and-address"
        v-if="Array.isArray(itemFiedParsed.tags) && itemFiedParsed.tags.length"
      >
        <ul
          :class="
            itemFiedParsed.tags.length
              ? 'consult-common-list-item-tags'
              : 'consult-common-list-item-tags-empty'
          "
        >
          <li
            v-for="(v, i) in itemFiedParsed.tags"
            :key="i"
            class="consult-common-list-item-tags-item"
          >
            <span class="consult-common-list-item-tag">{{ v }}</span>
          </li>
        </ul>

        <span
          class="consult-common-list-item-address"
          v-if="itemFiedParsed.city"
        >
          <icon name="dingwei1" class="icon-address" />{{ itemFiedParsed.city }}
        </span>
      </div>

      <template v-if="activityStyle === 1">
        <ul
          class="consult-common-list-item-v5-ab-activities"
          v-if="activityLabel.length || item.preActivity"
        >
          <!-- 节日活动标签 -->
          <li
            class="consult-common-list-item-v5-ab-combo-tag-new"
            v-if="item.preActivity"
          >
            <div
              class="consult-common-list-item-v5-ab-combo-tag-new-pre"
              v-if="item.preActivity.prefix_name"
            >
              {{ item.preActivity.prefix_name }}
            </div>
            <div
              class="consult-common-list-item-v5-ab-combo-tag-new-name"
              v-if="item.preActivity.name"
            >
              {{ item.preActivity.name }}
            </div>
          </li>
          <li
            class="consult-common-list-item-v5-ab-outline-tag new"
            v-for="v in activityLabel"
            :key="v"
          >
            {{ v }}
          </li>
        </ul>
      </template>

      <ul
        class="consult-common-list-item-activities"
        v-else-if="activitiesNames && activitiesNames.length"
      >
        <li
          class="consult-common-list-item-outline-tag"
          v-for="v in activitiesNames"
          :key="v"
        >
          {{ v }}
        </li>
      </ul>

      <div
        class="consult-common-list-item-schedule"
        v-if="
          itemFiedParsed.schedule && !Array.isArray(itemFiedParsed.schedule)
        "
      >
        <icon name="shijian" class="icon-schedule" />最快可约{{
          itemFiedParsed.schedule.date
        }}&nbsp;{{ itemFiedParsed.schedule.time }}
      </div>

      <div class="consult-common-list-item-time" v-if="created">
        <icon name="shijian" class="icon-schedule" />{{ created }}入驻
      </div>

      <template v-if="itemFiedParsed.activity_prices">
        <template v-if="isShowActivityPricesDetail">
          <ul class="consult-common-list-item-way-price">
            <li
              v-if="+v?.rest_quota !== 0"
              v-for="(v, i) in itemFiedParsed.activity_prices"
              :key="i"
              class="consult-common-list-item-way-price-item"
            >
              <span class="way-price-waytype">
                {{ waytypeMatchs[v.waytype] }}:
              </span>
              <div class="way-price-price">
                <p class="way-price-origin-price" v-show="v.origin_price">
                  <del>(￥{{ +v.origin_price }})</del>
                </p>
                <p class="consult-common-list-item-price">{{ +v.price }}</p>
              </div>
              <span
                v-if="v.rest_quota != undefined"
                :class="[
                  'consult-common-list-item-outline-tag',
                  'way-price-tag',
                  v.rest_quota !== 0 ? 'orange' : 'grey'
                ]"
              >
                {{
                  v.rest_quota === -1
                    ? '不限名额'
                    : '剩' + v.rest_quota + '名额'
                }}
              </span>
            </li>
          </ul>
        </template>
        <div class="consult-common-list-item-waytype" v-else>
          参与方式：{{
            itemFiedParsed.activity_prices
              .map(v => waytypeMatchs[v.waytype])
              .join('/')
          }}<span
            v-if="item.rest_quota != undefined"
            :class="[
              'consult-common-list-item-outline-tag',
              'text-way-price-tag',
              'orange'
            ]"
          >
            {{
              item.rest_quota === -1
                ? '不限名额'
                : '剩' + item.rest_quota + '名额'
            }}
          </span>
        </div>
      </template>

      <template v-if="itemFiedParsed.full_minus_prices">
        <ul class="consult-common-list-item-full-minus-price">
          <li
            class="consult-common-list-item-full-minus-price-item"
            v-for="(v, i) in itemFiedParsed.full_minus_prices.slice(0, 3)"
            :key="i"
          >
            <span>
              {{
                99 > +v.max_zx_num
                  ? +v.max_zx_num === +v.zx_num
                    ? `${v.zx_num}次立减${v.coupon_price}元`
                    : `${v.zx_num}-${v.max_zx_num}次立减${v.coupon_price}元`
                  : `${v.zx_num}次起立减${v.coupon_price}元`
              }}
            </span>
          </li>
        </ul>
      </template>

      <div
        class="consult-common-list-item-recommend"
        v-if="itemFiedParsed.recommend"
      >
        <p>{{ itemFiedParsed.recommend }}</p>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import { imgZip } from 'app/web/filters/ossImg.js'

const defaultFileds = [
  'avatar',
  'user_id',
  'name',
  'zx_num',
  'experience_year',
  'origin_price',
  'price',
  'honor',
  'tags',
  'city'
]

export default {
  props: {
    showMatchRate: Boolean,
    item: {
      type: Object
    },

    exclude: {
      type: Array,
      default() {
        return []
      }
    },

    include: {
      type: Array,
      default() {
        return ['schedule', 'tags', 'activities_names', 'recommend']
      }
    },

    // 参与方式 和 详细优惠价格 需要区分判断
    isShowActivityPricesDetail: {
      type: Boolean,
      default() {
        const { activity_prices } = this
        if (!Array.isArray(activity_prices)) return false
        if (activity_prices.length === 0) return false

        const { rest_quota, origin_price } = activity_prices[0]

        return origin_price !== undefined && rest_quota !== undefined
      }
    },

    stat: {
      type: String,
      default: '点击咨询师'
    },

    trackName: {
      type: String
    },
    trackParams: {
      type: Object,
      default: () => {}
    },

    listIndex: {
      type: [String, Number]
    },
    priceFilterInt: {
      type: Boolean,
      default: false
    },
    // 是否显示左上角推荐图标
    isShowRecommendIcon: {
      type: Boolean,
      default: false
    },
    isShowSchedule: {
      type: Boolean,
      default: false
    },
    isHalfPriceAb: {
      type: Boolean,
      default: false
    },
    customLabels: {
      type: Array,
      default: () => []
    },
    activityStyle: {
      type: Number,
      default: 0
    }
  },
  computed: {
    waytypeMatchs() {
      return { voice: '语音', video: '视频', face: '面对面' }
    },
    itemFiedParsed() {
      const { item, include, exclude } = this
      const _item = {}

      let fileds = [...include, ...defaultFileds]

      for (let i = 0; i < fileds.length; i++) {
        const key = fileds[i]
        if (exclude.indexOf(key) === -1) {
          _item[key] = item[key]
        }
      }
      const { price, origin_price: oPrice } = _item
      if (this.priceFilterInt) {
        _item.priceInt = !price ? price : Math.floor(price)
        _item.oPriceInt = !oPrice ? oPrice : Math.floor(oPrice)
      }
      return _item
    },
    activitiesNames() {
      const { activities_names } = this.itemFiedParsed
      return activities_names && activities_names.filter(v => !!v)
    },
    created() {
      const { created } = this.itemFiedParsed

      return created ? created.replace(/-/gi, '.') : ''
    },

    // 清除左右空格，原因：后台编辑器不编辑直接保存的话，会保存一堆空格，
    recommend() {
      const { recommend } = this.itemFiedParsed
      return typeof recommend === 'string' ? recommend.trim() : ''
    },
    activityLabel() {
      // 标签展示优先级：优惠券>预沟通>半价>满减>学生优惠
      const { coupons = [], activities } = this.item
      const { new_consult_visit, is_student } = this.indexUser
      let list = []
      if (coupons && coupons.length) {
        list.push(coupons[0].name)
      }
      const activityIdOrder = [41, 39, 40, 59]
      if (activities && activities.length) {
        activityIdOrder.forEach(id => {
          // 老来访不展示半价
          if (id === 39 && !new_consult_visit) {
            return
          }
          // 非认证不显示学生优惠
          if (id === 59 && !is_student) {
            return
          }
          const target = activities.find(item => {
            return +item.id === id
          })
          // 满减多个标签：标签数=4-（预沟通+半价的标签个数)
          if (id === 40 && target?.show_price?.length) {
            target.show_price = target.show_price.slice(
              0,
              4 - (list.length - coupons.length)
            )
          }
          if (target?.show_price?.length) {
            list.push(...target.show_price)
          }
        })
      }
      list = list.slice(0, this.item.preActivity ? 3 : 4)
      return list
    },
    indexUser() {
      return this.$store.state.consultindex.indexUser
    }
  },
  methods: {
    imgZip,
    _toTeacherList() {
      const { user_id, name, is_promotion } = this.item
      if (this.trackName) {
        const { pageName } = this.$route.meta || ''
        try {
          this.$trackEvent(this.trackName, {
            page_title: pageName,
            item_location: this.listIndex || '',
            psychologist_name: name || '',
            psychologist_id: user_id || '',
            is_promotion: !!+is_promotion,
            ...this.trackParams
          })
        } catch (error) {
          console.log(error)
        }
      }

      if (this.$listeners.toTeacherPage) {
        return this.$emit('toTeacherPage', this.item)
      }

      const { channel_flag, cid, channel_id } = this.$route.query
      return this.routerPushWithoutNav({
        path: `/consult/${user_id}.html`,
        query: {
          channel_flag: channel_flag,
          cid: cid || channel_id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.consult-common-list-item {
  &.full-minus-list-item {
    padding-bottom: 20px;
  }
  &.show-schedule-item {
    .consult-common-list-item-avatar {
      width: 140px;
      height: 140px;
    }
    &:not(:nth-last-child(1)):before {
      left: 140 + 30 + 20px;
    }
    .consult-common-list-item-content {
      & > *:not(:nth-last-child(1)) {
        margin-bottom: 14px;
      }
    }
    .consult-common-list-item-activities {
      padding-top: 6px;
    }
  }
  padding: 30px;
  display: flex;
  position: relative;

  &:not(:nth-last-child(1)):before {
    position: absolute;
    left: 106 + 30 + 20px;
    right: 30px;
    bottom: 0;
    border-bottom: 1px solid #f3f4f5;
    content: '';
    transform: scaleY(0.5);
  }

  &-avatar {
    border-radius: 20px;
    margin-right: 20px;
    width: 106px;
    height: 106px;
    display: block;
    background-size: cover;
    background-position: center;
    position: relative;
    background-color: rgba(0, 0, 0, 0.05);
    .recent-tag {
      width: 60px;
      height: 22px;
      margin-left: 7px;
      position: absolute;
      left: 0;
      bottom: 0;
      &-pay {
        background: url(~app/web/images/consult/expertList/tag-pay.png)
          no-repeat center / 100% 100%;
      }
      &-view {
        background: url(~app/web/images/consult/expertList/tag-view.png)
          no-repeat center / 100% 100%;
      }
    }
    .match-rate {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffa202;
      white-space: nowrap;
      position: absolute;
      left: 50%;
      transform: translate3d(-50%, 120%, 0);
      bottom: 0;
      box-sizing: border-box;
    }
    &-corner {
      position: absolute;
      top: 0;
      left: -4px;
      width: 43px;
      height: 30px;
    }
  }

  &-content {
    align-self: center;
    flex: 1;
    & > *:not(:nth-last-child(1)) {
      margin-bottom: 10px;
    }
  }

  &-info {
    display: flex;
    color: #21252d;
    align-items: flex-end;
  }

  &-name {
    font-size: 32px;
    line-height: 35px; // hack: iOS下，如果出现省略号，会显示出来一小部分第二行
    height: 34px;
    padding-right: 20px;
    font-weight: bold;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    max-width: 32 * 5px;
  }

  &-zx-num,
  &-cur,
  &-experience-year {
    font-size: 22px;
    line-height: 24px;
    padding-right: 10px;
    white-space: nowrap;
  }
  &-price {
    font-size: 32px;
    font-weight: 500;
    color: #ffa202;
    line-height: 32px;
    font-weight: bold;
    margin-bottom: -5px;
    vertical-align: bottom;
    white-space: nowrap;

    &:before {
      content: '¥ ';
      font-size: 20px;
    }
  }

  &-info-price {
    flex: 1;
    white-space: nowrap;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  &-origin-price {
    color: #9da3ac;
    font-size: 22px;
    line-height: 1.1;
    padding-right: 10px;
  }

  &-honer {
    font-size: 24px;
    font-weight: 400;
    color: #6c798c;
    line-height: 34px;
    word-break: break-all;
    // padding: 15px 0;
    @include overLine(1);
  }

  &-tags-and-address {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-tags {
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #6c798c;
    line-height: 40px;
    overflow: hidden;
  }

  &-tags-item {
    display: inline-block;
    background: #f2f4ff;
    border-radius: 6px;
    padding-left: 5px;
    // 特殊处理，让item超过容器掉落，用js计算不合适
    &:not(:nth-child(1)) {
      margin-left: -5px;
    }
    &:not(:nth-child(1)) {
      &::before {
        content: '|';
      }
    }
  }

  &-tag {
    padding: 0 15px;
  }

  &-address {
    font-size: 22px;
    color: #bcc2cf;
    line-height: 40px;
    flex-shrink: 0;

    .icon-address {
      font-size: 20px;
      line-height: 40px;
      padding-right: 5px;
    }
  }

  &-outline-tag {
    padding: 0 6px;
    font-size: 22px;
    color: #ffa202;
    line-height: 30px;
    height: 30px;
    display: inline-flex;
    align-items: baseline;
    box-sizing: border-box;
    margin-bottom: 3px;
    position: relative;
    border-width: 0;
    padding-top: 1px;
    &.new {
      padding-top: 0;
    }
    &::after {
      content: ' ';
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #ffc766;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      box-sizing: border-box;
      border-radius: 12px;
    }
    &:not(:nth-last-child(1)) {
      margin-right: 10px;
    }
    &.orange {
      border-color: #ff745b;
      color: #ff745b;
    }
    &.grey {
      border-color: #9da3ac;
      color: #9da3ac;
    }
  }

  &-activities {
    // height: 30px;
    // overflow: hidden;
    height: 30px;
    padding-bottom: 2px; // hack iOS部分设备地步切割
    overflow: hidden;
  }

  &-time,
  &-schedule {
    font-weight: 400;
    line-height: 1.25;

    .icon-schedule {
      font-size: 20px;
      padding-right: 10px;
    }
  }

  &-time {
    font-size: 22px;
    color: #9da3ac;
  }
  &-schedule {
    font-size: 22px;
    color: #6982fa;
  }

  &-waytype {
    font-size: 24px;
    color: #6c798c;
    line-height: 1.25;

    .text-way-price-tag {
      margin-left: 10px;
    }
  }

  &-way-price {
    font-size: 0;
    line-height: 0;
    margin-top: -20px;
  }

  &-way-price-item {
    display: inline-flex;
    // justify-content: center;
    align-items: flex-end;
    width: 50%;
    padding-top: 20px;

    .way-price-waytype {
      font-size: 24px;
      color: #6c798c;
      line-height: 40px;
    }

    .way-price-price {
      padding-left: 10-5px;
      padding-right: 16-5px;
      text-align: center;
    }

    .way-price-origin-price {
      font-size: 16px;
      color: #bcc2cf;
      line-height: 1.25;
    }
    .way-price-tag {
      margin-bottom: 5px;
      font-size: 18px;
    }
  }

  &-way-price-item-ab {
    display: inline-flex;
    margin-top: 26px;
    width: 166px;
    border-radius: 6px;
    flex-direction: column;
    &:not(:last-child) {
      margin-right: 16px;
    }
    &.disable {
      filter: grayscale(100%);
      .waytype-quota,
      .waytype-quota span,
      .way-price-price {
        color: #9da3ac;
      }
    }
    .waytype-quota {
      font-size: 20px;
      font-weight: 400;
      color: #21252d;
      line-height: 38px;
      box-sizing: border-box;
      padding-left: 12px;
      height: 38px;
      background: url('~images/consult/half-price/bg-quota.png') no-repeat
        center/100%;
      span {
        font-weight: 600;
        color: #6982fa;
      }
      .mini {
        font-size: 18px;
      }
    }
    .way-price-price {
      height: 54px;
      box-sizing: border-box;
      padding-left: 7px;
      font-size: 30px;
      font-weight: 600;
      color: #ffa202;
      line-height: 54px;
    }
    .way-price-origin-price {
      font-size: 16px;
      font-weight: 400;
      color: #bcc2cf;
      margin-left: 5px;
      vertical-align: middle;
    }
  }

  &-full-minus-price {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }

  &-full-minus-price-item {
    font-size: 22px;
    color: #ff745b;
    padding: 4px 6px;
    border-radius: 6px;
    border: 1px solid #ff745b;
    margin-right: 10px;
    margin-bottom: 10px;
    span {
      display: block;
    }
  }

  &-recommend {
    padding: 20px 28px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px #ececec;
    border-radius: 20px;
    margin-top: 14px;
    margin-bottom: 20px;
    p {
      font-size: 24px;
      font-weight: 400;
      color: #6d7588;
      line-height: 36px;
      word-break: break-all;
      @include overLine(5);
    }
  }
  .van-hairline--surround::after {
    border-color: #e5e8fa;
    border-radius: 6px;
  }

  &-combo-tag-new {
    // border: 1px solid #ffa08f;
    font-size: 22px;
    line-height: 30px;
    height: 30px;
    display: inline-flex;
    align-items: baseline;
    box-sizing: border-box;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    position: relative;
    border-width: 0;
    &::after {
      content: ' ';
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #ffa08f;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      box-sizing: border-box;
      border-radius: 12px;
    }
    &-pre {
      padding: 0 10px;
      background: linear-gradient(180deg, #ff745b 0%, #fc7052 100%);
      color: #fff;
    }
    &-name {
      padding: 0 6px;
      color: #fe7258;
      border-radius: 6px;
      box-sizing: content-box;
    }
  }
}
.consult-common-list-item-v5-ab {
  &-activities {
    margin-top: -10px;
    max-height: 82px;
    padding-bottom: 2px; // hack iOS部分设备地步切割
    overflow: hidden;
  }
  &-combo-tag {
    border: 1px solid #fd7256;
    font-size: 22px;
    line-height: 30px;
    height: 30px;
    display: inline-flex;
    align-items: baseline;
    box-sizing: border-box;
    margin-top: 10px;
    margin-right: 4px;
    border-radius: 8px;
    overflow: hidden;
    &-pre {
      padding: 0 8px;
      background: linear-gradient(180deg, #ff745b 0%, #fc7052 100%);
      color: #fff;
    }
    &-name {
      padding: 0 4px;
      color: #fe7258;
      border-radius: 8px;
      box-sizing: content-box;
    }
  }
  &-outline-tag {
    padding: 0 6px;
    font-size: 22px;
    color: #ffa202;
    line-height: 30px;
    height: 30px;
    display: inline-flex;
    align-items: baseline;
    box-sizing: border-box;
    margin-top: 10px;
    position: relative;
    border-width: 0;
    padding-top: 1px;
    &::after {
      content: ' ';
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #ffc766;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      box-sizing: border-box;
      border-radius: 12px;
    }
    &:not(:nth-last-child(1)) {
      margin-right: 10px;
    }
    &.orange {
      border-color: #ff745b;
      color: #ff745b;
    }
    &.grey {
      border-color: #9da3ac;
      color: #9da3ac;
    }
  }
}
</style>
